/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'
import {
  IconButton as Button,
  TextButton,
} from '@twistopayments/design-system/components/atoms/button'
import type { IconComponent } from '@twistopayments/design-system/icons'
import * as InlineSvgIcons from '@twistopayments/design-system/icons/inline'
import { hiddenDown } from '@twistopayments/design-system/styles'

import type { ArticleIconButtonComponent, LinkUrl } from '@twisto/api-cms'

import { getLinkUrl } from 'homepage/utils'

import { iconButton } from './button.styles'

type IconButtonProps = {
  styles?: ReturnType<typeof css>
  hideOnMobile?: boolean
}

export const IconButton = ({
  iconName,
  url,
  background,
  text,
  variant,
  styles,
  hideOnMobile,
}: ArticleIconButtonComponent & IconButtonProps) => {
  const link = getLinkUrl({ url } as LinkUrl)

  const icon = iconName
    ? (InlineSvgIcons as Record<string, IconComponent>)[iconName] ?? null
    : null

  if (!icon) {
    return null
  }

  if (!text) {
    return (
      <Button
        color={background}
        css={[hideOnMobile && hiddenDown('xs')]}
        href={link}
        icon={icon}
      />
    )
  }

  const RenderIcon = icon

  return (
    <div css={[iconButton, styles, hideOnMobile && hiddenDown('xs')]}>
      <TextButton color={background} href={link} variant={variant || 'default'}>
        <RenderIcon />
        {text}
      </TextButton>
    </div>
  )
}
